export { default as polyfillContext } from './polyfill-context';
export { default } from './polyfill-context';
//# sourceMappingURL=index.js.map